import axios from 'axios';

let prefix = "/brand"

const BrandApi = {
	
	getBrandList(payload){
		return axios.get( prefix + "/list", {params: payload})
	},
	getBrandById(id, payload){
		return axios.get( prefix + "/get/" + id, {params: payload})
	},
	createBrand(payload){
		return axios.post( prefix + "/create", payload)
	},
	updateBrand(payload){
		return axios.post( prefix + "/update", payload)
	},
	archiveBrand(payload){
		return axios.delete( prefix + "/delete", {params: payload})
	},

}

export default BrandApi;